import React from "react";

const RetailAgentAgreement = () => {
  return (
    <section
      id="retail_agent_agreement"
      className="ico_about_section section_space section_decoration bg-white"
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">TOPCOIN UK LTD</h5>
            <p className="text-dark opacity-75">
              <strong>RETAIL M AGENT &amp; SENIOR RETAIL AGENT AGREEMENT</strong>
            </p>

            <h5 className="title_text text-dark">Agent Participation Notice</h5>
            <p className="text-dark opacity-75">
              Members who wish to participate as a Retail M Agent or Senior
              Retail Agent and be eligible to receive TopCoin recognition
              settlement under Clause 10 of this Agreement must carefully read
              and accept the terms of this Agreement before participating as a
              retail agent within the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Participation as a Retail Agent and eligibility for recognition
              settlement is available only to members who accept this Agreement
              through the platform registration process.
            </p>
            <p className="text-dark opacity-75">
              This Agreement governs participation in the TopCoin UK Retail
              Network by members who wish to introduce and support retail
              businesses participating in the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd operates as a Retail &amp; Loyalty Platform
              connecting customers with participating retail businesses.
            </p>

            <h5 className="title_text text-dark">
              Refer Once — Recognition Continues While the Retailer Uses the
              Platform
            </h5>
            <p className="text-dark opacity-75">
              Retail agents introduce retailers to the platform once.
            </p>
            <p className="text-dark opacity-75">
              Recognition linked to those retailers may continue while the
              retailer remains active within the TopCoin UK platform according to
              platform operational rules.
            </p>

            <h5 className="title_text text-dark">Platform Growth Principle</h5>
            <p className="text-dark opacity-75">
              TopCoin UK grows through retail participation.
            </p>
            <p className="text-dark opacity-75">
              Members who introduce retailers help expand the platform retail
              network and may receive TopCoin and Bonus recognition linked to
              activity generated through participating retailers according to the
              operational rules of the platform.
            </p>

            <h5 className="title_text text-dark">Network Growth Principle</h5>
            <p className="text-dark opacity-75">
              Every retailer introduced to the TopCoin platform becomes part of
              the introducing agent’s network.
            </p>
            <p className="text-dark opacity-75">
              As those retailers continue to participate in the platform, the
              agent’s network may grow alongside the platform.
            </p>

            <h5 className="title_text text-dark">1. Platform Purpose</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd operates as a Retail &amp; Loyalty Platform
              connecting customers with participating retail businesses.
            </p>
            <p className="text-dark opacity-75">
              Retail businesses may choose to offer TopCoin and Bonus recognition
              to customers as part of their loyalty promotions.
            </p>
            <p className="text-dark opacity-75">
              TopCoin represents platform recognition only and does not
              represent:
            </p>
            <ul>
              <li className="text-dark opacity-75">Money</li>
              <li className="text-dark opacity-75">A financial investment</li>
              <li className="text-dark opacity-75">A savings product</li>
              <li className="text-dark opacity-75">
                A guaranteed financial return
              </li>
            </ul>

            <h5 className="title_text text-dark">2. Retail M Agent Role</h5>
            <p className="text-dark opacity-75">
              Members may apply to participate as Retail M Agents.
            </p>
            <p className="text-dark opacity-75">
              Retail M Agents support the growth of the platform by:
            </p>
            <ul>
              <li className="text-dark opacity-75">
                Introducing shops and retailers to the TopCoin platform
              </li>
              <li className="text-dark opacity-75">
                Explaining the TopCoin loyalty system to businesses
              </li>
              <li className="text-dark opacity-75">
                Supporting the onboarding of participating retailers
              </li>
            </ul>
            <p className="text-dark opacity-75">
              Retail M Agents operate independently and are not employees,
              partners, or representatives of TopCoin UK Ltd.
            </p>

            <h5 className="title_text text-dark">
              3. Retail Recognition for M Agents
            </h5>
            <p className="text-dark opacity-75">
              Where retailers introduced by a Retail M Agent participate in the
              platform and provide TopCoin and Bonus recognition to their
              customers, the Retail M Agent may receive:
            </p>
            <ul>
              <li className="text-dark opacity-75">TopCoin recognition</li>
              <li className="text-dark opacity-75">Bonus recognition</li>
            </ul>
            <p className="text-dark opacity-75">
              linked to the activity generated by those retailers according to
              platform rules.
            </p>
            <p className="text-dark opacity-75">
              Recognition remains linked to platform activity, not recruitment
              itself.
            </p>

            <h5 className="title_text text-dark">
              4. Eligibility for Senior Retail Agent Status
            </h5>
            <p className="text-dark opacity-75">
              A Retail M Agent may become eligible for recognition as a Senior
              Retail Agent after introducing a minimum of 50 participating retail
              businesses to the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Eligibility remains subject to review and approval by TopCoin UK
              Ltd.
            </p>

            <h5 className="title_text text-dark">5. Senior Retail Agent Role</h5>
            <p className="text-dark opacity-75">
              Senior Retail Agents support the development and expansion of
              retail participation within the TopCoin platform.
            </p>
            <p className="text-dark opacity-75">Senior Retail Agents may:</p>
            <ul>
              <li className="text-dark opacity-75">
                Support and guide Retail M Agents
              </li>
              <li className="text-dark opacity-75">
                Promote the TopCoin platform to retail businesses
              </li>
              <li className="text-dark opacity-75">
                Help expand the network of participating retailers
              </li>
            </ul>

            <h5 className="title_text text-dark">
              6. Retail Recognition for Senior Retail Agents
            </h5>
            <p className="text-dark opacity-75">
              Senior Retail Agents may receive TopCoin and Bonus recognition
              linked to activity generated by retailers within their supported
              network according to platform operational rules.
            </p>

            <h5 className="title_text text-dark">7. Advertising Participation</h5>
            <p className="text-dark opacity-75">
              Retail agents may also apply to participate in the Advertising
              Agent structure of the platform.
            </p>
            <p className="text-dark opacity-75">
              Retail agents may apply to become:
            </p>
            <ul>
              <li className="text-dark opacity-75">
                Customer Advertising M Agent
              </li>
              <li className="text-dark opacity-75">Senior Advertising Agent</li>
            </ul>
            <p className="text-dark opacity-75">
              Participation may be governed by the Advertising Agent Agreement.
            </p>

            <h5 className="title_text text-dark">
              8. Agent Recognition Settlement
            </h5>
            <p className="text-dark opacity-75">
              TopCoin and Bonus recognition recorded through retail agent
              participation represent platform recognition linked to retailer
              activity within the platform.
            </p>
            <p className="text-dark opacity-75">
              Agents may accumulate TopCoin and Bonus recognition based on
              activity generated through the retail network.
            </p>
            <p className="text-dark opacity-75">
              Where applicable and subject to platform rules, agents may request
              settlement of recorded balances through TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              Agents remain responsible for their own tax obligations where
              applicable.
            </p>

            <h5 className="title_text text-dark">9. Conduct &amp; Compliance</h5>
            <p className="text-dark opacity-75">
              Agents must promote the platform responsibly and must not:
            </p>
            <ul>
              <li className="text-dark opacity-75">
                Present TopCoin as an investment opportunity
              </li>
              <li className="text-dark opacity-75">
                Guarantee financial returns
              </li>
              <li className="text-dark opacity-75">
                Misrepresent the TopCoin platform
              </li>
            </ul>
            <p className="text-dark opacity-75">
              Failure to comply may result in suspension or removal from the
              platform.
            </p>

            <h5 className="title_text text-dark">10. Independent Participation</h5>
            <p className="text-dark opacity-75">Agents participate independently.</p>
            <p className="text-dark opacity-75">Nothing in this Agreement creates:</p>
            <ul>
              <li className="text-dark opacity-75">Employment</li>
              <li className="text-dark opacity-75">Partnership</li>
              <li className="text-dark opacity-75">Joint venture</li>
              <li className="text-dark opacity-75">
                Authority to legally bind TopCoin UK Ltd
              </li>
            </ul>

            <h5 className="title_text text-dark">11. Brand Protection</h5>
            <p className="text-dark opacity-75">
              All TopCoin branding, platform systems, technology, and
              operational structure remain the property of TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              Agents may not copy, replicate, or misuse the platform or brand.
            </p>

            <h5 className="title_text text-dark">12. Confidential Information</h5>
            <p className="text-dark opacity-75">
              Information relating to the TopCoin platform, systems, technology,
              and operations is confidential and may not be disclosed or used
              outside the platform.
            </p>

            <h5 className="title_text text-dark">13. International Participation</h5>
            <p className="text-dark opacity-75">
              Participants operating outside the United Kingdom must comply with
              the laws and regulations of their own jurisdiction.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd accepts no responsibility for local regulatory
              requirements.
            </p>

            <h5 className="title_text text-dark">14. Limitation of Liability</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd shall not be liable for actions, statements, or
              promotions conducted independently by agents.
            </p>
            <p className="text-dark opacity-75">
              Agents remain responsible for their own conduct.
            </p>

            <h5 className="title_text text-dark">15. Platform Discretion</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd reserves the right to update or modify platform
              operational rules, recognition structures, and systems when
              necessary for platform stability.
            </p>

            <h5 className="title_text text-dark">16. Platform Termination</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd may suspend or terminate participation where
              necessary to protect the platform or its community.
            </p>

            <h5 className="title_text text-dark">
              17. Platform Structure Ownership
            </h5>
            <p className="text-dark opacity-75">
              The TopCoin UK platform, technology, system architecture,
              recognition systems, and operational framework remain the exclusive
              property of TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              Participation in the platform does not grant agents any ownership
              rights in the platform structure.
            </p>

            <h5 className="title_text text-dark">18. Platform Network Protection</h5>
            <p className="text-dark opacity-75">
              Retail participation and retailer relationships exist within the
              TopCoin UK platform network.
            </p>
            <p className="text-dark opacity-75">
              Agents participate within the platform but do not obtain ownership
              or exclusive control over the platform network.
            </p>

            <h5 className="title_text text-dark">
              19. Platform Network Ownership — Retail Agents
            </h5>
            <p className="text-dark opacity-75">
              All retail businesses introduced to the TopCoin UK platform become
              participants within the TopCoin UK retail network.
            </p>
            <p className="text-dark opacity-75">
              Agents do not obtain ownership or exclusive rights over those
              retailers.
            </p>
            <p className="text-dark opacity-75">
              Retailers participate directly within the platform according to
              TopCoin UK operational rules.
            </p>

            <h5 className="title_text text-dark">
              20. No Lifetime Rights or Ownership Claims
            </h5>
            <p className="text-dark opacity-75">
              Participation as a Retail M Agent or Senior Retail Agent does not
              grant permanent or lifetime rights over retailers introduced to the
              platform.
            </p>
            <p className="text-dark opacity-75">
              TopCoin and Bonus recognition may only continue while the agent
              remains an active participant and while platform rules permit such
              recognition.
            </p>

            <h5 className="title_text text-dark">21. Governing Law</h5>
            <p className="text-dark opacity-75">
              This Agreement shall be governed by the laws of England and Wales.
            </p>

            <p className="text-dark opacity-75 mt-4">
              <strong>TopCoin UK Ltd</strong>
              <br />
              Retail &amp; Loyalty Platform
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetailAgentAgreement;

